import { Stack, styled, Typography } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';

export const HeaderBackground = styled(Stack)(({ theme }) => ({
  zIndex: 0,
  background: theme.palette.primary.headerGradient,
  borderRadius: '0px 0px 16px 16px',
  position: 'relative',
  left: '0px',
  top: '0px',
  alignSelf: 'stretch',
  width: '100%',
  minWidth: '90%',
  minHeight: '150px',
  height: '150px',
  padding: '0px',
  margin: '0px',
}));

export const ContentWrapper = styled(Stack)(({ theme }) => ({
  position: 'relative',
  margin: '0 auto',
  width: '90%',
  maxWidth: '1380px',
  minHeight: '150px',
  alignItems: 'center',
  flexDirection: 'row',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
  },
}));

export const UserStack = styled(Stack)(({ theme }) => ({
  gap: '8px',
  width: '100%',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  [theme.breakpoints.up('md')]: {
    width: '50%',
    flexDirection: 'row',
  },
}));
export const AvatarWrapper = styled(Stack)(({ theme }) => ({
  height: 'auto',
  [theme.breakpoints.between('sm', 'md')]: {
    height: '60px',
  },
}));
export const UserInfoStack = styled(Stack)(({ theme }) => ({
  justifyContent: 'center',
  height: 'auto',
  [theme.breakpoints.between('sm', 'md')]: {
    height: '60px',
    marginTop: '10px',
  },
  [theme.breakpoints.down('sm')]: {
    height: '60px',
  },
}));
export const UserInfoText = styled(Typography)(({ theme }) => ({
  color: theme.palette.white.main,
  fontWeight: 300,
  fontSize: theme.typography.returnText.fontSize,
  textAlign: 'left',
  [theme.breakpoints.down('md')]: {
    textAlign: 'center',
    fontSize: theme.typography.customButton.fontSize,
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: theme.typography.smallText.fontSize,
  },
}));

export const HeaderUserName = styled(Typography)(({ theme }) => ({
  textAlign: 'left',
  whiteSpace: 'pre-wrap',
  fontSynthesis: 'none',
  color: theme.palette.white.main,
  fontWeight: theme.typography.button.fontWeight,
  fontSize: theme.typography.titleText.fontSize,
  letterSpacing: '0px',
  textDecoration: 'none',
  lineHeight: '119.49999332427979%',
  textTransform: 'none',
  [theme.breakpoints.down('md')]: {
    fontSize: theme.typography.mediumText.fontSize,
    textAlign: 'center',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '0.875rem',
  },
}));

export const AvatarContainer = styled(Stack)({
  position: 'relative',
  isolation: 'isolate',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '0px',
  boxSizing: 'border-box',
  maxHeight: '120px',
  minWidth: '92.83px',
  maxWidth: '122px',
  width: '100%',
});

export const ProfileIcons = styled('img')(({ theme }) => ({
  width: '36px',
  height: '36px',
  position: 'absolute',
  right: '4px',
  bottom: '-6px',
  filter: 'drop-shadow(0px 0px 4px rgba(0,0,0,0.25))',
  [theme.breakpoints.down('md')]: {
    width: '28px',
    height: '28px',
    right: '14px',
    bottom: '-6px',
  },
  [theme.breakpoints.down('sm')]: {
    width: '22px',
    height: '22px',
    right: '20px',
    bottom: '-6px',
  },
}));

export const IconEditAvatar = styled(EditIcon)(({ theme }) => ({
  width: '30px',
  height: '30px',
  position: 'absolute',
  right: '8px',
  bottom: '-6px',
  color: theme.palette.primary.main,
  backgroundColor: theme.palette.white.main,
  filter: 'drop-shadow(0px 0px 4px rgba(0,0,0,0.25))',
  borderRadius: '100%',
  padding: '4px',
}));
